// Фирменный знак «Орбита». Важно: подложка-квадрат входит в сам SVG, а не задаётся
// фоном контейнера — тогда точки орбиты гарантированно лежат внутри бокса и ничего
// не вылезает на любом размере. Цвет ядра и точек — currentColor, искра — белая.
export function BrandMark() {
  return (
    <svg viewBox="0 0 48 48" aria-hidden="true">
      <g className="oa-brandmark-orbit">
        <circle className="oa-brandmark-ring" cx="24" cy="24" r="20.2" />
        <circle className="oa-brandmark-dot" cx="24" cy="3.8" r="2.3" />
        <circle className="oa-brandmark-dot" cx="41.5" cy="34.1" r="2.3" opacity=".82" />
        <circle className="oa-brandmark-dot" cx="6.5" cy="34.1" r="2.3" opacity=".7" />
      </g>
      <rect className="oa-brandmark-hub" x="10" y="10" width="28" height="28" rx="8.8" />
      <path
        className="oa-brandmark-spark"
        d="M24 14 L26.5 21.5 L34 24 L26.5 26.5 L24 34 L21.5 26.5 L14 24 L21.5 21.5 Z"
      />
    </svg>
  );
}
